export class SaleViewModel {
  constructor() {}
}
